import React from 'react';
import BudgetType from '../../../enums/budget-type';
import SubBudget from './components/sub-budget/sub-budget';

export default function BudgetLivestock() {
  return (
    <SubBudget
      revenuesName={BudgetType.REVENUES_ANIMAL}
      costsName={BudgetType.COSTS_ANIMAL}
      categorizedCostsName={BudgetType.CATEGORIZED_COSTS_ANIMAL}
    />
  );
}
